<template>
    <div class="kadru_addon clr">
        <standart title="Службова записка, щодо зміни штатного розпису"></standart>
        <div class="kadru_data">
            
            <div class="head">
                <div class="field" :class="head.class" v-for="head in addon_fields">
                    <div class="title_min">{{head.name}}</div>
                </div>
                <div class="clr"></div>
            </div>
            
            
            <div class="before_change">
                <div class="pre_title">
                    До змін
                </div>
                <b-form-input v-model="form.before_title" placeholder="Пiдроздiл"></b-form-input>
                
                <div class="fields_insert">
                    <div class="action_field" v-for="(row,idx) in rows_before">
                        <div class="field_insert" :class="item.class" v-for="(item,idx2) in addon_fields">
                            <b-form-input
                                v-if="rows_before[idx][idx2].insert_val !='numb'"
                                v-model="rows_before[idx][idx2].value">
                            
                            </b-form-input>
                            
                            <div class="np" v-else>{{ idx + 1 }}</div>
                        
                        </div>
                        <div class="remove_row" @click="remove_row('before',idx)">
                            <i class="fa fa-trash active color-danger-800 cursor-pointer" aria-hidden="true"></i>
                        </div>
                        <div class="clr"></div>
                    </div>
                </div>
                
                
                
                <div class="add user">
                    <i title="" class="fa add_user fa-plus-square color-primary-100 cursor-pointer fs-xxl" @click="add_row('before')"></i>
                </div>
            </div>
            
            <div class="after_change">
                <div class="pre_title">
                    Після змін
                </div>
                <b-form-input v-model="form.after_title" placeholder="Пiдроздiл"></b-form-input>
                
                <div class="add user">
                    <i title="" class="fa add_user fa-plus-square color-primary-100 cursor-pointer fs-xxl" @click="add_row('after')"  ></i>
                </div>
                
                <div class="fields_insert">
                    <div class="action_field" v-for="(row,idx) in rows_after">
                        <div class="field_insert" :class="item.class" v-for="(item,idx2) in addon_fields">
                            <b-form-input
                                v-model="rows_after[idx][idx2].value"
                                v-if="rows_after[idx][idx2].insert_val != 'numb'"
                            ></b-form-input>
                            <div class="np" v-else>{{ idx + 1 }}</div>
                        
                        </div>
                        <div class="remove_row" @click="remove_row('after',idx)">
                            <i class="fa fa-trash active color-danger-800 cursor-pointer" aria-hidden="true"></i>
                        </div>
                        
                        <div class="clr"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script >

    import {createHelpers} from 'vuex-map-fields';
    
    const {mapFields} = createHelpers({
        getterType: 'memorandum_create/getMemCreateField',
        mutationType: 'memorandum_create/updateMemCreateField',
    });

    import { VueEditor } from "vue2-editor";
    import standart from "../standart.vue";
    export default {
    name: "kadru",
    
    components : {
        standart,
        VueEditor
    },
    
    data () {
        return {
            rows_before : [],
            rows_after : [],
            form : {
                before_title : '',
                after_title : '',
            }
        }
    },
    methods : {
        add_row : function (type) {
            let arr_push = JSON.parse(JSON.stringify(this.addon_fields));
            
            if(type == 'before') {
                this.rows_before.push(arr_push);
            }
            
            if(type == 'after') {
                this.rows_after.push(arr_push);
            }
        },
        
        remove_row : function (type,idx) {
            if(type == 'before') {
                this.rows_before.splice(idx,1);
            }
            if(type == 'after') {
                this.rows_after.splice(idx,1);
            }
        },
    },
    
    
    computed: {
        ...mapFields([
            'active_memorandum'
        ]),
        
        addon_fields() {
            return this.active_memorandum.addon_data;
        },
        
        return_data : function () {
            this.form.r_before = this.rows_before;
            this.form.r_after = this.rows_after;
            return this.form;
        }
        
    },
}
</script>


<style scoped>

</style>